<template>
  <div>
    <top />
    <router-view></router-view>
    <bottom />
  </div>
</template>

<script>
import Bottom from "../components/Bottom";
import Top from "../components/Top";
export default {
  name: "index",
  components:{
    Bottom,
    Top,
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/index.vue